// extracted by mini-css-extract-plugin
export default {"ic":"style_ic__ND67m","small":"style_small__BrvVm","medium":"style_medium__Dhm6X","large":"style_large__dHLze","xl":"style_xl__0zCwv"};